import { useState } from 'react';
import { REVIEWS } from '../../config/site';

export default function Reviews() {
  const [current, setCurrent] = useState(0);
  const review = REVIEWS[current];

  return (
    <section id="reviews" className="py-16 md:py-24 bg-white scroll-mt-[132px]">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <h2 className="font-inter text-sm md:text-base font-medium tracking-[0.3em] uppercase text-text-primary mb-12">
          KIND WORDS
        </h2>

        <blockquote className="font-display text-2xl md:text-3xl leading-snug text-text-primary mb-6">
          “{review.quote}”
        </blockquote>
        <p className="font-inter text-xs tracking-[0.2em] uppercase text-text-muted">{review.author}</p>

        {REVIEWS.length > 1 && (
          <div className="flex justify-center items-center gap-3 mt-10">
            {REVIEWS.map((r, i) => (
              <button
                key={r.id}
                type="button"
                onClick={() => setCurrent(i)}
                className={`w-2.5 h-2.5 rounded-full border border-text-muted/30 cursor-pointer transition-all ${
                  i === current
                    ? 'bg-text-primary border-text-primary'
                    : 'bg-transparent hover:bg-text-muted/20'
                }`}
                aria-label={`Review ${i + 1} of ${REVIEWS.length}`}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
